/**
 * Centralized logging utility
 * Respects build environment - no logs in production
 */

class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
    this.isAdminMode =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.pathname.includes('admin') ||
        window.location.search.includes('admin=true'));
  }

  // Only log in development or admin mode
  shouldLog(level = 'log') {
    return this.isDevelopment || this.isAdminMode;
  }

  log(...args) {
    if (this.shouldLog('log')) {
      console.log(...args);
    }
  }

  warn(...args) {
    if (this.shouldLog('warn')) {
      console.warn(...args);
    }
  }

  error(...args) {
    // Always log errors, even in production
    console.error(...args);
  }

  info(...args) {
    if (this.shouldLog('info')) {
      console.info(...args);
    }
  }

  debug(...args) {
    if (this.shouldLog('debug')) {
      console.debug(...args);
    }
  }

  // Special method for development-only logs
  dev(...args) {
    if (this.isDevelopment) {
      console.log('[DEV]', ...args);
    }
  }

  // Special method for admin-only logs
  admin(...args) {
    if (this.isAdminMode) {
      console.log('[ADMIN]', ...args);
    }
  }

  // Method for important logs that should always show
  important(...args) {
    console.log('🔔', ...args);
  }
}

// Create and export singleton instance
const logger = new Logger();
export default logger;
